import { DefaultLoader, Loadable } from 'excalibur';


export class ShrapnelLoader extends DefaultLoader {
    constructor(resources?: Record<string, Loadable<any>>) {
        super({ loadables: Object.values(resources || {}) });
    }
};
